var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconChatCardIntroDiscuss(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 19.433a.586.586 0 1 0 0-1.173.586.586 0 0 0 0 1.173ZM15.5 19.433a.586.586 0 1 0 0-1.173.586.586 0 0 0 0 1.173ZM18.5 19.433a.586.586 0 1 0 0-1.173.586.586 0 0 0 0 1.173ZM6.13 19.433a3.948 3.948 0 1 1 0-7.896 3.948 3.948 0 0 1 0 7.896Zm0-6.725a2.777 2.777 0 1 0 0 5.553 2.777 2.777 0 0 0 0-5.553Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.173 26.494H1.086a.586.586 0 0 1-.586-.586V23.89a5.63 5.63 0 0 1 11.259 0v2.018a.585.585 0 0 1-.586.586Zm-9.501-1.172h8.915v-1.431a4.458 4.458 0 0 0-8.915 0v1.431ZM24.87 19.433a3.948 3.948 0 1 1 0-7.897 3.948 3.948 0 0 1 0 7.897Zm0-6.725a2.776 2.776 0 1 0 0 5.553 2.776 2.776 0 0 0 0-5.553Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.913 26.494H19.826a.586.586 0 0 1-.586-.586V23.89a5.63 5.63 0 0 1 11.26 0v2.018a.586.586 0 0 1-.587.586Zm-9.5-1.172h8.914v-1.431a4.458 4.458 0 0 0-8.915 0v1.431ZM12.83 15.35a.586.586 0 0 1-.586-.586v-1.731h-.586a1.912 1.912 0 0 1-1.91-1.91V5.416a1.912 1.912 0 0 1 1.91-1.91h7.562a1.912 1.912 0 0 1 1.91 1.91v5.707a1.912 1.912 0 0 1-1.91 1.91h-3.83l-2.146 2.145a.584.584 0 0 1-.414.172ZM11.658 4.678a.738.738 0 0 0-.738.738v5.707a.738.738 0 0 0 .738.739h1.172a.586.586 0 0 1 .586.585v.903l1.317-1.317a.582.582 0 0 1 .414-.172h4.074a.739.739 0 0 0 .738-.738V5.416a.738.738 0 0 0-.738-.738h-7.563Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h30v30H.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatCardIntroDiscuss);
export default __webpack_public_path__ + "static/media/icon_chat_card_intro_discuss.b7ca0d7924a28af0823e61f54148134d.svg";
export { ForwardRef as ReactComponent };